export function useTimeline() {
  const useTimelineSteps = (totalSteps: number, currentStep: number) => {
    return Array.from({ length: totalSteps }, (_, index) => {
      const stepNumber = index + 1;
      return {
        stepNumber,
        isActive: stepNumber === currentStep,
        isCompleted: stepNumber < currentStep,
        isLast: index === totalSteps - 1,
      };
    });
  };

  return {
    useTimelineSteps,
  };
}
